import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AdminComponent } from "./admin.component";
import { AuthGuard } from "src/app/guards/auth.guard";
import { AppRoutingPathType } from "src/app/constants/AppRoutingPathType";

export const routes: Routes = [
  {
    path: "",
    component: AdminComponent,
    children: [
      {
        path: "users",
        loadChildren: () =>
          import(`./users/users.module`).then((m) => m.UsersModule),
      },
      {
        path: "organisation-and-centre",
        loadChildren: () =>
          import(`./organisation-centre/organisation-centre.module`).then(
            (m) => m.OrganisationCentreModule
          ),
        canActivate: [AuthGuard],
        data: {
          appRoutingPathType: AppRoutingPathType.OrganisationAndCentre,
        },
      },
      {
        path: "groups",
        loadChildren: () =>
          import(`./groups/group.module`).then((m) => m.GroupModule),
      },
      {
        path: "learner-resources",
        loadChildren: () =>
          import(`../learner-resources/learner-resources.module`).then(
            (m) => m.LearnerResourceModule
          ),
      },
      {
        path: "reports",
        loadChildren: () =>
          import(`../reports/reports.module`).then((m) => m.ReportsModule),
      },
      {
        path: "",
        redirectTo: "users",
        pathMatch: "full",
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AdminRoutingModule {}
